import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './effects';
import { FEE_QUOTE_API_PROVIDERS } from './fee-quote/api';
import { reducers } from './reducers';
import { StoreModule } from '@ngrx/store';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(AppEffects),
  ],
  providers: [...FEE_QUOTE_API_PROVIDERS],
})
export class NgRxStoreModule {}
